import type { ReactNode } from "react";

export type WorkspaceTab = {
  key: string;
  label: string;
};

interface WorkspaceShellProps {
  title: string;
  subtitle: string;
  tabs: WorkspaceTab[];
  activeKey: string;
  onTabChange: (key: string) => void;
  children: ReactNode;
  rightSlot?: ReactNode;
  statPills?: ReactNode;
}

export default function WorkspaceShell({
  title,
  subtitle,
  tabs,
  activeKey,
  onTabChange,
  children,
  rightSlot,
  statPills,
}: WorkspaceShellProps) {
  return (
    <div className="workspace-canvas space-y-5">
      <header className="workspace-header-card rounded-3xl px-6 py-6">
        <div className="flex flex-wrap items-start justify-between gap-4">
          <div className="max-w-3xl space-y-2">
            <h1 className="workspace-title text-2xl font-bold md:text-3xl">{title}</h1>
            <p className="workspace-subtitle text-sm md:text-base">{subtitle}</p>
          </div>
          {rightSlot && <div className="flex items-center">{rightSlot}</div>}
        </div>
        {statPills && <div className="mt-4 flex flex-wrap items-center gap-2">{statPills}</div>}
      </header>

      <section className="workspace-tab-list rounded-2xl p-2">
        <div className="flex flex-wrap gap-2">
          {tabs.map((tab) => {
            const isActive = tab.key === activeKey;
            return (
              <button
                key={tab.key}
                type="button"
                onClick={() => onTabChange(tab.key)}
                className={`workspace-tab rounded-full px-4 py-2 text-sm font-semibold ${
                  isActive ? "workspace-tab-active" : ""
                }`}
              >
                {tab.label}
              </button>
            );
          })}
        </div>
      </section>

      {children}
    </div>
  );
}
